import { OutnessOptionsType } from './types';

export const OUTNESS_OPTIONS: OutnessOptionsType = [
  { id: 'open_proud', title: 'Openly out & proud' },
  { id: 'close_friends', title: 'Out to close friends only' },
  { id: 'not_out', title: 'Not out yet, private' },
  { id: 'exploring', title: 'Exploring & questioning' },
];
